import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2, ChevronLeft } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) navigate("/");
    else setErr(res.error);
  };

  return (
    <div className="min-h-screen bg-bg flex flex-col" data-testid="login-page">
      <div className="mx-auto w-full max-w-md flex-1 flex flex-col">
      <div className="px-4 pt-6">
        <button onClick={() => navigate(-1)} className="text-white/70 inline-flex items-center gap-1 text-sm" data-testid="login-back">
          <ChevronLeft size={18} /> Back
        </button>
      </div>
      <div className="flex-1 px-6 pt-10">
        <h1 className="font-heading font-extrabold text-4xl tracking-tight">
          Desh<span className="text-white">Flix</span>
          <sup className="text-brand text-xs font-bold tracking-widest ml-0.5">BD</sup>
        </h1>
        <p className="text-white/55 mt-2 text-sm">Sign in to save your favourite Bangla videos.</p>

        <form onSubmit={onSubmit} className="mt-10 space-y-4">
          <Field label="Email">
            <input
              type="email"
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              className="w-full bg-bg-surface border border-white/10 rounded-xl px-4 py-3 text-sm outline-none focus:border-brand transition"
              placeholder="you@example.com"
            />
          </Field>
          <Field label="Password">
            <input
              type="password"
              required
              minLength={6}
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              className="w-full bg-bg-surface border border-white/10 rounded-xl px-4 py-3 text-sm outline-none focus:border-brand transition"
              placeholder="••••••••"
            />
          </Field>

          {err && <p className="text-brand text-xs" data-testid="login-error">{err}</p>}

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full bg-brand hover:bg-brand-hover disabled:opacity-60 text-white font-semibold py-3 rounded-xl shadow-[0_0_20px_rgba(230,59,46,0.45)] inline-flex items-center justify-center gap-2 transition"
          >
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Log in"}
          </button>
        </form>

        <p className="text-white/55 text-sm text-center mt-8">
          New to DeshFlix?{" "}
          <Link to="/register" className="text-brand font-medium hover:underline" data-testid="goto-register">
            Create an account
          </Link>
        </p>
      </div>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <label className="block">
      <span className="text-xs uppercase tracking-wider text-white/55">{label}</span>
      <div className="mt-1">{children}</div>
    </label>
  );
}
